/*@ngInject*/
const RuleHeaderController = function ($rootScope, $scope, $element, $uibModal, configurationMediator, formViewerConstant, loadingBarHandler, localization, modalUtil, ruleUtil, uiFormTemplateModel, umStudioConstant, ruleModel) {

    $element.addClass('ruleHeader');

    this.umStudioConstant = umStudioConstant;

    localization.getTranslationByKey('ruleHeader').then(function (translations) {

        this.descriptionPlaceholder = _.get(translations, 'addADescription');
        this.ruleNamePlaceholder = _.get(translations, 'ruleNamePlaceholder');
        this.ruleNameSubstring = ruleUtil.getRuleNameSubstring(this.rule);

        this.$onChanges = function () {
            this.ruleNameSubstring = ruleUtil.getRuleNameSubstring(this.rule);
        };

        this.onRuleNameChange = () => {
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.onRuleNameBlur = function () {
            let ruleNameParts,
                oldRuleNameSubstring = ruleUtil.getRuleNameSubstring(this.rule),
                fieldRules = uiFormTemplateModel.getUiFormTemplate().fieldRules,
                duplicateFieldRuleIndex = -1,
                options;
            if (this.ruleNameSubstring !== oldRuleNameSubstring) {
                if (_.isEmpty(this.ruleNameSubstring)) {
                    this.ruleNameSubstring = oldRuleNameSubstring;
                    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);

                    options = {};
                    options.title = _.get(translations, 'errorModal.title');
                    options.summary = _.get(translations, 'errorModal.blankRule');
                    options.confirmActionButtonLabel = _.get(translations, 'errorModal.okButtonLabel');

                    var modalInstance = $uibModal.open({
                        templateUrl: '/ui/modal/modal.tpl.html',
                        controller: 'modalController',
                        windowClass: 'genericModal',
                        resolve: {
                            options: function () {
                                return options;
                            }
                        }
                    });

                    $scope.$broadcast(umStudioConstant.event.FOCUS_ON_RULE_NAME);
                } else {
                    if (this.isFieldRule) {
                        duplicateFieldRuleIndex = _.findIndex(fieldRules, function (fieldRule) {
                            return ruleUtil.getRuleNameSubstring(fieldRule) === this.ruleNameSubstring;
                        }.bind(this));
                    }

                    if (duplicateFieldRuleIndex !== -1) {
                        this.ruleNameSubstring = oldRuleNameSubstring;
                        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);

                        options = {};
                        options.title = _.get(translations, 'errorModal.title');
                        options.summary = _.get(translations, 'errorModal.uniqueRule');
                        options.confirmActionButtonLabel = _.get(translations, 'errorModal.okButtonLabel');

                        var modalInstance = $uibModal.open({
                            templateUrl: '/ui/modal/modal.tpl.html',
                            controller: 'modalController',
                            windowClass: 'genericModal',
                            resolve: {
                                options: function () {
                                    return options;
                                }
                            }
                        });

                        $scope.$broadcast(umStudioConstant.event.FOCUS_ON_RULE_NAME);
                    } else {
                        ruleUtil.updateUiFieldTriggerRuleNames(uiFormTemplateModel.getUiFormTemplate(), oldRuleNameSubstring, this.ruleNameSubstring);

                        if (!_.isNil(this.rule.name) && this.rule.name.lastIndexOf('-#') !== -1) {
                            ruleNameParts = _.split(this.rule.name, '-#');
                            this.rule.name = this.ruleNameSubstring + '-#' + ruleNameParts[1];
                        } else {
                            this.rule.name = this.ruleNameSubstring;
                        }
                    }
                }
            }
        };

        this.onDescriptionChange = function () {
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.reviewRule = function () {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'reviewRule.notificationMessage'));
            return configurationMediator.validateRule(this.rule).then(function (result) {
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                showValidateRuleModal(result);
            }, function (error) {
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
        };

        function showValidateRuleModal(validateRuleResult) {
            var instance = $uibModal.open({
                templateUrl: '/configuration/formEditor/content/rule/reviewRule/validateRuleModal.tpl.html',
                controller: 'validateRuleModalController',
                windowClass: 'validateRuleModal',
                resolve: {
                    options: function () {
                        return {
                            ruleText: validateRuleResult.ruleText,
                            error: validateRuleResult.errors
                        };
                    }
                }
            });
            return instance.result;
        }

    }.bind(this));
};

angular.module('umCore')
    .controller('ruleHeaderController', RuleHeaderController);
